<template>
  <div id="boton-impresion">
    <v-container grid-list-xl fluid>
      <v-layout>
        <v-flex lg12>
          <v-card>
            <boton-proceso :lstBtn="lstBtn"></boton-proceso>
          </v-card>
          <div v-if="loading">
            <loading></loading>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import axios from "axios";
import MiniStatistic from "@/components/widgets/statistic/MiniStatistic";
import Material from "vuetify/es5/util/colors";
import BotonProceso from "@/modules/configuration/commonsviews/BotonProceso.vue";
import SubProcesoImpresion from "@/modules/impresion/views/proceso/SubProcesoImpresion.vue";
import Loading from "@/views/ui/Loading.vue";

export default {
  name: "boton-impresion",

  components: {
    MiniStatistic,
    SubProcesoImpresion,
    BotonProceso,
    Loading,
  },
  data: () => ({
    color: Material,
    iconoBoton: "fa-print",
    tituloBoton: "Mecanizado",
    colorBoton: "yellow darken-4",
    lstBtn: [],
    lstBtnCompleta: [
      {
        icon: "fa-print",
        title: "Impresion",
        subtitle: "",
        color: "yellow darken-3",
        class: "impresion rombo elevation-10",
        subPro: "IMPRESION", //valor para subproceso en BotonProceso.vue
        tab: "Acuerdo", //valor para tab en BotonProceso.vue
      },
      {
        icon: "all_inbox",
        title: "Mecanizado",
        subtitle: "",
        color: "purple darken-2",
        class: "mecanizado rombo elevation-10",
        subPro: "MECANIZADO",
        tab: "Acuerdo",
      },
      {
        icon: "local_shipping",
        title: "Distribucion",
        subtitle: "",
        color: "teal",
        class: "distribucion rombo elevation-10",
        subPro: "DISTRIBUCION",
        tab: "Acuerdo",
      },
      {
        icon: "event_note",
        title: "Administrativo",
        subtitle: "",
        color: "blue darken-3",
        class: "administrativo rombo elevation-10",
        subPro: "ADMINISTRATIVO",
        tab: "Administrativo",
      },
      {
        icon: "today",
        title: "Visitas",
        subtitle: "",
        color: "light-green darken-2",
        class: "visitas rombo elevation-10",
        subPro: "VISITAS",
        tab: "Visitas",
      },
      {
        icon: "all_inbox",
        title: "Prod&Report",
        subtitle: "",
        color: "yellow darken-3",
        class: "prod rombo elevation-10",
        subPro: "PROD",
        tab: "Productos",
      },
    ],
  }),
  computed: {},
  Mounted() {},
  created() {
    this.loadDataPanelControl();
  },
  methods: {
    async loadDataPanelControl() {
      this.loading = true;
      let lstBtnTmp = await this.loadPanelControl();
      for (let i = 0; i < lstBtnTmp.length; i++) {
        this.lstBtn.push(this.lstBtnCompleta[lstBtnTmp[i] - 1]);
      }
      this.loading = false;
    },
    async loadPanelControl() {
      return await axios
        .get(
          "/panelControl/posicionActivos/" + this.$store.getters.contratoStored
        )
        .then(function (response) {
          return response.data;
        })
        .catch(function (error) {
          console.log("error loadPanelControl:" + error);
        });
    },
  },
};
</script>
